import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Card } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd, Spin } from 'antd';
import { TitlePage } from '@src/@styles/styles.global';
import LoteDoacaoServices from './services';
import api from '@http/api';
import { PictureAsPdf } from '@material-ui/icons';


import { useAuth } from '@hooks/AuthenticateContext';

const { Option } = SelectAntd;

const DoacaoLote: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [lotes, setLotes] = useState<any[]>([]);
  const [formref] = Form.useForm();
  const services = new LoteDoacaoServices();
  const [loadingVerificarLote, setLoadingVerificarLote] = useState(false);
  const [loteExists, setLoteExists] = useState(false);
  const [loteSelecionado, setLoteSelecionado] = useState<any>();





  useEffect(() => {
    window.document.title = 'CRM - Lote doações';
    carregarLotesAbertos();
    loadVerificaLoteAberto();
  }, []);

  const carregarLotesAbertos = async () => {
    setLoading(true);
    const result = await services.GetLotesAbertos();
    if (!result.error) {
      setLotes(result.data);
    } else {
      //enqueueSnackbar('Não há nenhum lote aberto', { variant: 'error' });
      console.log(result.error)
    }
    setLoading(false);
  };

const handleAbrirLote = async () => {
   if (loteExists === true) {
      enqueueSnackbar('Há um lote em aberto', { variant: 'warning' });
      return;
    }
  setLoadingCreate(true);

    const { error } = await services.AbrirLote();

    //setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar('Lote aberto com sucesso!', { variant: 'success' });
      formref.resetFields();
      await carregarLotesAbertos();
      await loadVerificaLoteAberto();
    } else {
      enqueueSnackbar('Erro ao fechar lote', { variant: 'error' });
    }
    setLoadingCreate(false);

  }


  const handleFecharLote = async () => {
    const id_lote = formref.getFieldValue('lote');

    setLoteSelecionado(id_lote);
    if (!id_lote) {
      enqueueSnackbar('Selecione um lote para fechar', { variant: 'warning' });
      return;
    }

    setLoadingCreate(true);
    const result = await services.FecharLote({ id_lote });
    if (!result.error) {
      enqueueSnackbar('Lote fechado com sucesso!', { variant: 'success' });
      formref.resetFields();
      await carregarLotesAbertos();
      await loadVerificaLoteAberto();
    } else {
      enqueueSnackbar('Erro ao fechar lote', { variant: 'error' });
    }
    setLoadingCreate(false);
  };


  async function loadVerificaLoteAberto() {
    setLoadingVerificarLote (true)
    await api
      .get('/api/LoteDoacao/possui-lote-aberto')

      .then(async response => {
       // setTiposPerfis(response.data.pessoa.tipo_perfil_descricao);

       setLoteExists(response.data);

        //removeLoading();
        setLoadingVerificarLote(false);
      })
      .catch(error => {
        console.log(error);
      });
  }

  console.log('loeteee', loteSelecionado)

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Gerenciar lote</TitlePage>
      </Grid>

      <Grid container item xs={12} lg={12} style={{ marginTop: 20 }}>
        <Grid item lg={12} sm={12} xs={12}>
          <Spin size="large" spinning={loadingCreate} tip="Enviando dados...">
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError
              labelAlign="left"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* 🔹 ABRIR LOTE */}
                <Grid container item lg={4} sm={4} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item md={12} xs={12}>
                      <TitlePage style={{ margin: 5 }}>Abrir um lote</TitlePage>
                    </Grid>
                    <Grid container justifyContent="center" alignItems="center" item lg={12} md={12} xs={12}>
                      <Grid item lg={10} md={10} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          onClick={handleAbrirLote}
                        >
                          Abrir
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid container item lg={1} sm={1} xs={12} style={{ padding: 0 }}></Grid>

                {/* 🔹 FECHAR LOTE */}

                <Grid container item lg={4} sm={4} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item md={12} xs={12}>
                      <TitlePage style={{ margin: 5 }}>Fechar um lote</TitlePage>
                    </Grid>

                    <Grid container>
                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="lote" label="Lote">
                          <SelectAntd
                            style={{ width: '100%' }}
                            placeholder={loading ? 'Carregando...' : 'Selecione um lote'}
                            loading={loading}
                          >
                            {lotes.map(lote => (
                              <Option key={lote.id} value={lote.id}>
                                 {lote.id + " - " + lote.descricao}
                              </Option>
                            ))}
                          </SelectAntd>
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid container justifyContent="center" alignItems="center" item lg={12} md={12} xs={12}>
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          onClick={() => formref.resetFields()}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          onClick={handleFecharLote}
                        >
                          Fechar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid container item lg={1} sm={1} xs={12} style={{ padding: 0 }}></Grid>

                {/* 🔹 RELATORIO LOTE */}

                <Grid container item lg={2} sm={2} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item md={12} xs={12}>
                      <TitlePage style={{ margin: 5 }}>Relatório</TitlePage>
                    </Grid>
                    <Grid container justifyContent="center" alignItems="center" item lg={12} md={12} xs={12}>
                      <Grid item lg={10} md={10} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                      <ButtonComponent
              color="secondary"
              fullWidth
              disabled={!loteSelecionado}
              style={{ height: 37, width: 150 }}
              onClick={async () => {
                if (!loteSelecionado) return;

                const {error, response} = await services.gerarRelatorio(Number(loteSelecionado));

                if (!error && response instanceof Blob) {
                  const fileURL = URL.createObjectURL(response);
                  const link = document.createElement('a');
                  link.href = fileURL;

                  const contentDisposition = response.type;
                  const fileName = `Relatorio_Lote_${loteSelecionado}.pdf`;

                  link.setAttribute('download', fileName);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);

                  URL.revokeObjectURL(fileURL);

                  enqueueSnackbar('Recibo baixado com sucesso', {
                    variant: 'success',
                    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },

                  });
                  setLoteSelecionado(undefined);
                } else {
                  enqueueSnackbar('Erro ao gerar recibo', {
                    variant: 'error',
                    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                  });
                }
              }



            }

            >
              <PictureAsPdf style={{ marginRight: 10 }} /> Gerar
            </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DoacaoLote;
